import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { openConsentSettings } from "./ConsentBanner";

export const Footer = () => (
  <footer data-testid="site-footer" className="overflow-hidden border-t border-white/10 bg-[#121211] text-[var(--stone)]">
    <div className="mx-auto max-w-[1440px] px-5 pt-16 sm:px-8 lg:px-12">
      <div className="flex flex-col justify-between gap-10 md:flex-row">
        <Logo light />
        <div className="flex flex-wrap items-center gap-8 text-sm text-white/75">
          <Link to="/impressum" data-testid="footer-impressum-link" className="transition-colors hover:text-[#E3A68F]">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="transition-colors hover:text-[#E3A68F]">Datenschutz</Link>
          <button type="button" onClick={openConsentSettings} data-testid="footer-consent-settings" className="text-left transition-colors hover:text-[#E3A68F]">Datenschutz-Einstellungen</button>
          <a href="mailto:kontakt@aufbruchwerk.de" data-testid="footer-email-link" className="transition-colors hover:text-[#E3A68F]">kontakt@aufbruchwerk.de</a>
        </div>
      </div>
      <p className="font-serif-d mt-16 select-none whitespace-nowrap text-[15vw] leading-[0.8] tracking-[-0.04em] text-white/[0.08]" aria-hidden="true">aufbruchwerk.de</p>
      <div className="flex flex-col justify-between gap-2 border-t border-white/10 py-6 text-xs text-white/60 sm:flex-row">
        <span>© 2026 Aufbruchwerk · ein Angebot der StackStork UG (haftungsbeschränkt)</span>
        <span className="font-mono-d">Raum · IT · Nachfolge</span>
      </div>
    </div>
  </footer>
);
